<template>
  <div
    :class="needPadding === 'true' ? 'padding-top' : ''"
    :style="GetWindowInfoStyle"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'FullScreen',
  props: {
    imgSrc: {
      type: String
    },
    needPadding: {
      type: String,
      default: 'false'
    }
  },
  data () {
    return {
      GetWindowInfoStyle: {
        height: '', // 动态获取content高度
        width: '100%', // 动态获取content宽度
        backgroundImage: 'url(' + this.imgSrc + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'center'
      }
    }
  },
  methods: {
    GetWindowInfo () {
      console.log('innerHeight', window.innerHeight)
      console.log('innerWidth', window.clientWidth)
      this.GetWindowInfoStyle.height = window.innerHeight + 'px'
      // this.GetWindowInfoStyle.width = window.innerWidth + 'px';
    }
  },
  created () {
    console.log(this.imgSrc)
    window.addEventListener('resize', this.GetWindowInfo) // 注册监听器
    this.GetWindowInfo() // 页面创建时先调用一次
  },
  destroyed () {
    window.removeEventListener('resize', this.GetWindowInfo)
  }
}
</script>
<style scoped>
.padding-top {
  padding-top: 120px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/common/FullScreen.vue